import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"
import { useSelectedCourse } from "../../stores/use-selected-course"
import { useEffect } from "react"

export default function useGetMySituation() {
  const { selectedCourse } = useSelectedCourse()

  const query = useQuery({
    queryKey: ["get-my-situation", selectedCourse?.id],
    queryFn: () => api.cronos.tracking.students.get(selectedCourse?.id as string),
    enabled: !!selectedCourse?.id,
    staleTime: 1000 * 60 * 60 * 24, // 1 day
    select: (data) => data.data.description,
  })

  useEffect(() => {
    if (selectedCourse) {
      query.refetch()
    }
  }, [selectedCourse?.id])

  return query
}
